import I18n from 'I18n';
import { PlaylistAssignmentsSearch, usePlaylistAssignmentsSearchContext } from './PlaylistAssignmentsSearch';
import { UnAssignPlaylistButton } from './UnAssignPlaylistButton';
import { CardMenuOptions } from '../../cardMenu/components/CardMenu';
import { SideNavItem } from 'foundations-components/transitional/components/SideNav';
import { Button } from 'foundations-components/transitional/components/Button';
import formatName from 'I18n/utils/formatName';
import AvatarViewer from '../../avatar/components/AvatarViewer';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { LeftIcon } from 'foundations-assets/icons/components/LeftIcon';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const UnassignPlaylistHeader = () => {
  const {
    selectedPortalId,
    unselectPortal
  } = usePlaylistAssignmentsSearchContext();
  return selectedPortalId ? /*#__PURE__*/_jsxs(Button, {
    onClick: unselectPortal,
    use: "link",
    children: [/*#__PURE__*/_jsx(LeftIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.playlistAssignments.backLink"
    })]
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "learningCenter.playlistAssignments.unassignPlaylist"
  });
};
export const UnassignPlaylistLoadMore = () => {
  const {
    selectedPortalId
  } = usePlaylistAssignmentsSearchContext();
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: selectedPortalId ? 'learningCenter.cardMenu.loadMoreAssignments' : 'learningCenter.cardMenu.loadMorePortals'
  });
};
const UnassignPlaylistPortalList = ({
  portals,
  renderList = content => /*#__PURE__*/_jsx(CardMenuOptions, {
    "aria-label": I18n.text('learningCenter.playlistAssignments.portalsHeader'),
    children: content
  }),
  renderRow = (content, key) => /*#__PURE__*/_jsx(SideNavItem, {
    title: content
  }, key),
  onPortalClick
}) => {
  return renderList(portals && portals.map(({
    portal: {
      id,
      companyName,
      domain
    },
    playlistId
  }) => {
    return renderRow( /*#__PURE__*/_jsx(Button, {
      block: true,
      onClick: () => {
        if (onPortalClick) onPortalClick(id);
      },
      use: "unstyled",
      children: /*#__PURE__*/_jsx(View, {
        inlineSize: "100%",
        textAlign: "start",
        children: companyName || domain
      })
    }), `portal_${playlistId}_${id}`);
  }));
};
const UnassignPlaylistAssignmentList = ({
  assignments,
  renderList = content => /*#__PURE__*/_jsx(CardMenuOptions, {
    "aria-label": I18n.text('learningCenter.playlistAssignments.portalsHeader'),
    children: content
  }),
  renderRow = (content, key) => /*#__PURE__*/_jsx(SideNavItem, {
    title: content
  }, key),
  onAssignmentClick,
  onUnassigned
}) => {
  const handleOnUnassigned = (portalId, assignmentId) => {
    if (onUnassigned) onUnassigned(portalId, assignmentId);
  };
  return renderList(assignments && assignments.map(({
    playlistId,
    portalId,
    id,
    assignee: {
      avatarHash,
      firstName,
      lastName
    }
  }) => {
    const displayName = formatName({
      firstName,
      lastName
    });
    return renderRow( /*#__PURE__*/_jsx(UnAssignPlaylistButton, {
      assignments: [id],
      onDeleted: () => handleOnUnassigned(portalId, id),
      render: ({
        handleOnClick
      }) => /*#__PURE__*/_jsx(Button, {
        block: true,
        onClick: e => {
          handleOnClick(e);
          if (onAssignmentClick) onAssignmentClick(portalId, id);
        },
        use: "unstyled",
        children: /*#__PURE__*/_jsx(TFlex, {
          children: /*#__PURE__*/_jsx(AvatarViewer, {
            avatarHash: avatarHash,
            displayName: displayName,
            renderName: true,
            size: "xs",
            type: "contact"
          })
        })
      })
    }), `portal_${playlistId}_${portalId}_${id}`);
  }));
};
export const UnAssignPlaylist = ({
  playlistId,
  renderList,
  renderRow,
  loadMoreButton,
  onPortalClick,
  onAssignmentClick,
  onUnassigned
}) => {
  const {
    selectPortal
  } = usePlaylistAssignmentsSearchContext();
  const handleOnPortalClick = portalId => {
    selectPortal(portalId);
    if (onPortalClick) onPortalClick(portalId);
  };
  return /*#__PURE__*/_jsx(PlaylistAssignmentsSearch, {
    loadMoreButton: loadMoreButton,
    playlistId: playlistId,
    renderAssignments: assignments => assignments && /*#__PURE__*/_jsx(UnassignPlaylistAssignmentList, {
      assignments: assignments,
      onAssignmentClick: onAssignmentClick,
      onUnassigned: onUnassigned,
      renderList: renderList,
      renderRow: renderRow
    }),
    renderPortals: portals => portals && /*#__PURE__*/_jsx(UnassignPlaylistPortalList, {
      onPortalClick: handleOnPortalClick,
      portals: portals,
      renderList: renderList,
      renderRow: renderRow
    })
  });
};
export default UnAssignPlaylist;